import React from 'react';
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Box } from '../UI-CHAKRA/Box';
import { Flex } from '../UI-CHAKRA/Flex';
import { Text } from '../UI-CHAKRA/Text';
import { Button } from '../UI-CHAKRA/Button';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/mevo/ic-exit-rounded-purple.svg';

interface PspCancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PspCancelModal: React.FC<PspCancelModalProps> = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.5)" backdropFilter="blur(2px)" />
      <ModalContent
        maxW={{ base: '90%', md: '500px' }}
        borderRadius={'20px'}
        padding={'0px'}
        boxShadow={'0px 0px 20px 7px rgba(0,0,0,0.25)'}
      >
        <Box padding={'24px'} position={'relative'}>
          <Box position={'absolute'} top={'20px'} right={'20px'}>
            <CloseIcon onClick={onClose} cursor={'pointer'} />
          </Box>

          <Text fontSize={'20px'} fontWeight={700} color={'#343A40'} mb={'16px'}>
            Deseja cancelar o pré-cadastro?
          </Text>

          <Text fontSize={'14px'} color={'#545C62'} mb={'24px'} lineHeight={'20px'}>
            Ao sair agora, o processo será interrompido e o paciente não será vinculado ao Programa de Suporte ao
            Paciente.
          </Text>

          <Flex gap={'12px'} justifyContent={'flex-end'}>
            <Button
              onClick={onConfirm}
              padding="10px 20px"
              backgroundColor={'#FFF'}
              borderWidth={'2px'}
              borderColor={'primary.main'}
              borderStyle={'solid'}
              borderRadius={'20px'}
              _hover={{ backgroundColor: '#FFF', borderColor: '#6B409C' }}
            >
              <Text fontSize={'14px'} color={'primary.main'}>
                Sim, cancelar
              </Text>
            </Button>
            <Button
              onClick={onClose}
              padding="10px 20px"
              backgroundColor={'primary.main'}
              borderRadius={'20px'}
              _hover={{ backgroundColor: '#6B409C' }}
            >
              <Text fontSize={'14px'} color={'#FFF'}>
                Voltar para o cadastro
              </Text>
            </Button>
          </Flex>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default PspCancelModal;
